import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { templatesApi } from '../api/index.js';
import { ApiError } from '../api/client.js';
import { ClaudeHint } from '../components/ClaudeHint.js';

export function TemplateNewPage() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [html, setHtml] = useState('');
  const [error, setError] = useState('');

  const mutation = useMutation({
    mutationFn: () => templatesApi.create({ title, description, html }),
    onSuccess: (data) => {
      void qc.invalidateQueries({ queryKey: ['templates'] });
      navigate(`/templates/${data.template.id}`);
    },
    onError: (err) => setError(err instanceof ApiError ? err.message : 'Failed to create template'),
  });

  return (
    <div>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '1.5rem' }}>New Template</h1>

      <ClaudeHint
        title="Create from an existing document with Claude"
        prompt="Use the create-template-from-document skill. I have an existing [Word/PDF/HTML] document and want to turn it into a reusable template with fillable fields."
      />

      <div className="card" style={{ marginTop: '1.5rem' }}>
        <h2 style={{ fontWeight: 600, marginBottom: '1rem' }}>Create manually</h2>
        {error && <div className="alert alert-error">{error}</div>}
        <form
          onSubmit={(e) => {
            e.preventDefault();
            mutation.mutate();
          }}
        >
          <div className="form-group">
            <label>Title *</label>
            <input value={title} onChange={(e) => setTitle(e.target.value)} required />
          </div>
          <div className="form-group">
            <label>Description</label>
            <input value={description} onChange={(e) => setDescription(e.target.value)} />
          </div>
          <div className="form-group">
            <label>HTML *</label>
            <p style={{ fontSize: '.8rem', color: 'var(--color-text-muted)', marginBottom: '.5rem' }}>
              Use <code>{'{{field_name}}'}</code> for fillable fields. Fields will be inferred automatically.
            </p>
            <textarea
              value={html}
              onChange={(e) => setHtml(e.target.value)}
              rows={12}
              required
              style={{ fontFamily: 'monospace', fontSize: '.85rem' }}
            />
          </div>
          <button className="btn btn-primary" type="submit" disabled={mutation.isPending}>
            {mutation.isPending ? 'Creating…' : 'Create Template'}
          </button>
        </form>
      </div>
    </div>
  );
}
